import { environment } from '../../../environments/environment';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
declare let gtag: any; // グローバル変数gtagを解決

export class ExtendsMainComponent {

  // 2重送信不可フラグ
  public submitFlg = false;

  /**
   * イベント：エラー時の画面スクロール
   */
  scrollError(event?: string, messages?: any[]) {

    // エラーメッセージをGAに送信する
    if (event != null && messages != null && messages.length > 0) {
      let eventParam = '{';
      for (let i = 1; i <= messages.length; i++) {
        eventParam = eventParam + '"message' + i + '":"' + messages[i - 1].msg + '"';
        if (i < messages.length) {
          eventParam = eventParam + ',';
        }
      }
      eventParam = eventParam + '}';
      gtag('event', event, JSON.parse(eventParam));
    }

    this.scrolltoId('scrollError');
  }

  /**
   * 指定されたURLに画面遷移します.
   *
   * @param url 遷移させたいURL
   */
  locationAssign(url: string) {

    // 二重送信不可
    if (this.submitFlg) {
      return;
    }
    this.submitFlg = true;

    location.href = url;
  }

  /**
   * 共通初期設定
   */
  config() {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.analyticsId;
    document.getElementById('gaid').appendChild(script);
  }

  /**
   * 指定のURLにsubmitします.
   *
   * @param url URL
   * @param requestParam パラメータ {name: value}
   */
  onSubmit(url: string, requestParams: any) {

    // 二重送信不可
    if (this.submitFlg) {
      return;
    }
    this.submitFlg = true;

    // form作成
    const form = document.createElement('form');
    form.action = url;
    form.method = 'post';
    // パラメータ設定
    for (const key of Object.keys(requestParams)) {

      const q = document.createElement('input');
      q.type = 'hidden';
      q.name = key;
      q.value = requestParams[key];
      form.appendChild(q);
    }

    // 念のためIE対策としてhtmlに埋め込む
    document.body.appendChild(form);

    // submitを実行
    form.submit();
  }

  /**
   * イベント：指定のIDに画面スクロール
   *
   * @param scrollId スクロールさせたいID
   */
  scrolltoId(scrollId: string) {
    const scrollPosition = document.getElementById(scrollId);
    if (scrollPosition !== null) {
      const errorX = window.pageYOffset + scrollPosition.getBoundingClientRect().left;
      const errorY = window.pageYOffset + scrollPosition.getBoundingClientRect().top;
      window.scrollTo(errorX, errorY);
    }
  }
}
